// Демо-состояния сессии повторения (`?demo=`) — ОДИН источник для схемы
// search-параметров роута и для пропа встроенного движка. Не мёртвый код: ими
// показывают состояния при ревью UI (`docs/ui-spec/flashcards.study.*`).
export const FLASHCARD_STUDY_DEMOS = [
	"default",
	"loading",
	"empty",
	"streaming",
	"end-of-deck",
	"quota-exceeded",
] as const;

export type FlashcardStudyDemo = (typeof FLASHCARD_STUDY_DEMOS)[number];
